import React, { useState } from 'react'

import { pathOr } from 'ramda'

import { Button, ButtonGroup } from '@driftt/dds'
import { Div, Input, Label, Span } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@driftt/tide-modal'

import { createSendingDomain } from './api'

const DEFAULT_KEY_LENGTH = 1024
const ADVANCED_KEY_LENGTH = 2048
const NO_MATCHING_USER_DOMAIN_ERROR =
  'no user in your org has an email with that domain!'

const CreateDomainModal = ({ onClose, onCreate }) => {
  const [error, setError] = useState(null)
  const [email, setEmail] = useState('')
  const [keyLength, setKeyLength] = useState(DEFAULT_KEY_LENGTH)
  const [isSaving, setIsSaving] = useState(false)

  const domain =
    email && email.split('@').length > 1 ? email.split('@')[1] : null

  const handleCreate = () => {
    setIsSaving(true)
    createSendingDomain(domain, keyLength)
      .then((res) => onCreate(res))
      .catch((e) => {
        const errMessage = pathOr('', ['response', 'data', 'message'], e)
        if (errMessage === NO_MATCHING_USER_DOMAIN_ERROR) {
          setError(
            'Domain could not be created -- there is no user on the account with that domain name.'
          )
        } else {
          setError('An error occurred')
        }
      })
      .finally(() => setIsSaving(false))
  }

  const onEmailChange = (e) => setEmail(e.target.value)

  return (
    <Modal open="on" size="small" onClose={onClose}>
      <ModalTitle>New domain</ModalTitle>
      <ModalBody>
        <Input
          label="Example email to send from"
          type="email"
          className="create-domain-modal--email-input"
          value={email}
          onChange={onEmailChange}
          placeholder="me@mydomain.com"
        />
        <Div>
          <Label>DKIM key bit length</Label>
          <label className="create-domain-modal--radio">
            <Input
              type="radio"
              onChange={() => setKeyLength(DEFAULT_KEY_LENGTH)}
              checked={keyLength === DEFAULT_KEY_LENGTH}
            />
            <Span>1024 (Recommended)</Span>
          </label>
          <label className="create-domain-modal--radio">
            <Input
              type="radio"
              onChange={() => setKeyLength(ADVANCED_KEY_LENGTH)}
              checked={keyLength === ADVANCED_KEY_LENGTH}
            />
            <Span>2048 (Advanced)</Span>
          </label>
        </Div>
        {error && <p className="create-domain-modal--error">{error}</p>}{' '}
      </ModalBody>
      <ModalFooter>
        <ButtonGroup>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            className="create-domain-modal--confirm-button"
            onClick={handleCreate}
            disabled={!domain}
            loading={isSaving}
          >
            Save
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  )
}

export default CreateDomainModal
